<div class="header">
  <div class="header-subtitle-admin">{{'' | i18n: 'models'}}.</div>
  <div>
    <div class="button-container">
      <button (click)="addNewModel()">{{'' | i18n: 'add-model-code'}}</button>
    </div>
  </div>
</div>
<div>{{'' | i18n: 'search-model-code'}}:</div>

<div class="search-panel">
  <div class="search form-group">
    <span>
      <input type="text" id="model_search" name="modelCode" [(ngModel)]="modelFilter.modelCode"
        placeholder="Search..." (keydown.enter)="fetchModels()">
        <button style="width: 35px">
          <i (click)="fetchModels()" class="fa fa-search" aria-hidden="true"></i>
        </button>
        <button style="width: 35px">
          <i (click)="clearModelSearch()" class="fa fa-times" aria-hidden="true"></i>
        </button>
      </span>
    </div>

    <div class="paginator">
      <span style="width: 20px">
        <button class="button button-page" (click)="changeModelPage(-1)" [disabled]="this.modelFilter.page == 0">
          <img alt="" src="assets/images/BMW-previous-144.png" width="20px" height="20px">
        </button>
      </span>
      <span class="pagination-number"> {{modelFilter.page + 1}} </span>
      <span style="width: 20px">
        <button class="button paginator-button" (click)="changeModelPage(1)"
          [disabled]="this.modelList?.pageCount <= this.modelFilter.page">
          <img alt="" src="assets/images/BMW-next-144.png" width="20px" height="20px">
        </button>
      </span>
    </div>
  </div>

  <div> {{''|i18n:'search-make'}}:</div>
  <div class="brand-selector">
    <select [(ngModel)]="selectedBrand" (change)="onBrandSelected($event)">
      <option [value]="null">{{''| i18n:'select'}}</option>
      @for (brand of brands; track brand) {
        <option [ngValue]="brand">{{brand.name}}</option>
      }
    </select>
  </div>

  <div class="form-row-container-config">
    <div class="table-header">
      <div class="tbl-header-12">
        <a (click)="sort()">{{'' | i18n: 'model-code'}}
          <img src="{{updateIconStatus()}}" alt=""
          class="sort-img"/></a>
        </div>
        <div class="tbl-header-20">{{'' | i18n: 'description'}}</div>
        <div class="tbl-header-20">{{'' | i18n: 'model-group'}}</div>
        <div class="tbl-header-20">{{'' | i18n: 'fuel'}}</div>
        <div class="tbl-header-12">{{'' | i18n: 'cylinder'}}</div>
        <div class="tbl-header-20">{{'' | i18n: 'make'}}</div>
        <div class="tbl-header-20">{{'' | i18n: 'update'}}</div>
      </div>

      @for (m of modelList?.dataList; track m) {
        <div class="table-list">
          @if (m.id) {
            <div class="tbl-content-12">{{m.modelNumber}}</div>
          }
          @if (!m.id) {
            <div class="tbl-content-12"><input type="text" [(ngModel)]="m.modelNumber"></div>
          }
          <div class="tbl-content-20"><input type="text" [(ngModel)]="m.model"></div>
          <div class="tbl-content-20">
            <select [(ngModel)]="m.modelGroup" [compareWith]="compare">
              <option value="null">Please select</option>
              @for (modelGroup of modelGroups; track modelGroup) {
                <option [ngValue]="modelGroup">
                  {{modelGroup.description}}
                </option>
              }
            </select>
          </div>
          <div class="tbl-content-20">
            <select [(ngModel)]="m.fuel" [compareWith]="compareFuel">
              @for (fuel of fuels; track fuel) {
                <option [ngValue]="fuel">
                  {{fuel}}
                </option>
              }
            </select>
          </div>
          <div class="tbl-content-12"><input type="number" [(ngModel)]="m.cylinder"></div>
          <div class="tbl-content-20"><input type="text" [(ngModel)]="m.modelGroup?.make.name"></div>
          <div class="tbl-content-20">
            @if (m.id) {
              <button class="button button-white" (click)="updateModel(m)">{{'' | i18n: 'update'}}</button>
            }
            @if (!m.id) {
              <button class="button button-white" (click)="updateModel(m)">{{'' | i18n: 'save'}}</button>
            }
            @if (!m.id) {
              <span>
                <button class="button button-white" (click)="removeModel(m)">{{'' | i18n: 'delete'}}</button>
              </span>
            }
          </div>
        </div>
      }
    </div>
